import React from 'react';
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube, ArrowUpRight } from 'lucide-react';
import { navLinks } from '../mock';
import Logo from './Logo';

const Footer = () => {
  const handleClick = (href) => (e) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1a1410] text-[#F7F4EA] pt-20 pb-10 relative overflow-hidden">
      <div className="absolute -top-32 left-1/3 w-[420px] h-[420px] rounded-full bg-[#F58220]/12 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-4 gap-12">
        <div className="lg:col-span-2">
          <Logo variant="full" theme="light" size={42} showTagline={true} />
          <p className="mt-6 text-[14px] leading-[1.85] text-[#F7F4EA]/70 max-w-md">
            Veetu Saama is a modern home & appliances retail brand, making
            quality products for every home accessible, trusted and enjoyable.
            From kitchens to living, we bring the best brands, great service
            and a better everyday for families.
          </p>

          <div className="mt-8 flex gap-3">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-10 h-10 rounded-full border border-[#F7F4EA]/15 flex items-center justify-center hover:bg-[#F58220] hover:border-[#F58220] transition-all duration-400 group"
              >
                <Icon className="w-4 h-4 text-[#F58220] group-hover:text-white transition-colors duration-400" strokeWidth={1.7} />
              </a>
            ))}
          </div>
          <div className="mt-6 font-script text-[24px] text-[#F58220]">For a Better Tomorrow</div>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.28em] font-bold text-[#F58220] mb-5">
            Navigate
          </div>
          <ul className="space-y-3">
            {navLinks.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  onClick={handleClick(l.href)}
                  className="text-[14px] text-[#F7F4EA]/75 hover:text-[#F58220] transition-colors duration-300 inline-flex items-center gap-1.5 group"
                >
                  {l.label}
                  <ArrowUpRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-400" />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.28em] font-bold text-[#F58220] mb-5">
            Reach Us
          </div>
          <ul className="space-y-4 text-[14px] text-[#F7F4EA]/75">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-[#F58220] mt-0.5" strokeWidth={2} />
              <a href="tel:+917305970386" className="hover:text-[#F58220] transition-colors">+91 73059 70386</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-[#F58220] mt-0.5" strokeWidth={2} />
              <a href="mailto:contact@veetusaama.com" className="hover:text-[#F58220] transition-colors">contact@veetusaama.com</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#F58220] mt-0.5" strokeWidth={2} />
              <span>Adyar, Chennai<br />Tamil Nadu, India</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 mt-16 pt-8 border-t border-[#F7F4EA]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-[12px] text-[#F7F4EA]/50">
          © {new Date().getFullYear()} Veetu Saama • Everything for a Better Home
        </div>
        <div className="flex gap-6 text-[12px] text-[#F7F4EA]/55">
          <a href="#" className="hover:text-[#F58220] transition-colors">Privacy</a>
          <a href="#" className="hover:text-[#F58220] transition-colors">Terms</a>
          <a href="#" className="hover:text-[#F58220] transition-colors">Sitemap</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
